webpackJsonp([9],{

/***/ "1cPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFooterData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_jsonp_js__ = __webpack_require__("Gak4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__("T452");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





function getFooterData(lang) {
  var url = 'api/getFooterData';

  var data = { lang: lang };
  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
    params: data
  }).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

/***/ }),

/***/ "34KM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Q4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeClass;
/* unused harmony export getData */
/* unused harmony export prefixStyle */
function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className);
}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  var newClass = el.className.split(' ');
  newClass.push(className);
  el.className = newClass.join(' ');
}

function removeClass(el, className) {
  if (hasClass(el, className)) {
    var newClass = el.className.split(' ');
    for (var i = 0; i < newClass.length; i++) {
      if (newClass[i] == className) {
        newClass.splice(i, 1);
      }
    }
    el.className = newClass.join(' ');
  }
}

function getData(el, name, val) {
  var prefix = 'data-';
  if (val) {
    return el.setAttribute(prefix + name, val);
  }
  return el.getAttribute(prefix + name);
}

var element = document.createElement('div').style;

function elementStyle() {
  var transformName = {
    o: 'oTransform',
    ms: 'msTransform',
    moz: 'mozTransform',
    webkit: 'webkitTransform',
    stander: 'oTransform'
  };

  for (var key in transformName) {
    if (element[transformName[key]] !== undefined) {
      return key;
    }
  }

  return false;
}

function prefixStyle(style) {
  var vendor = elementStyle();
  if (vendor === false) {
    return false;
  }
  return vendor + style.charAt(0).toUpperCase() + style.substring(1);
}

/***/ }),

/***/ "44yY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"tabBox"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"menuWrapper"},[(_vm.menuArr.length>0)?_c('div',{ref:"menu",staticClass:"routerWrapper",on:{"click":function($event){$event.stopPropagation();_vm.selectMenu($event)}}},[_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/home"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[0].name.toUpperCase()))])]),_vm._v(" "),_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/products"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[1].name.toUpperCase()))])]),_vm._v(" "),_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/about"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[2].name.toUpperCase()))])]),_vm._v(" "),_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/contact"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[3].name.toUpperCase()))])]),_vm._v(" "),_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/certificate"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[4].name.toUpperCase()))])]),_vm._v(" "),_c('a',{staticClass:"tab-item",attrs:{"href":_vm.menuArr[5].link,"target":"_blank"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[5].name.toUpperCase()))])]),_vm._v(" "),_c('router-link',{staticClass:"tab-item",attrs:{"tag":"div","to":"/source"}},[_c('span',{staticClass:"tab-link"},[_vm._v(_vm._s(this.menuArr[6].name.toUpperCase()))])])],1):_vm._e()]),_vm._v(" "),_c('div',{ref:"menuIcon",staticClass:"menuIcon",on:{"click":_vm.miniMenu}},[_c('i',{ref:"icon",staticClass:"icon iconfont icon-menu"})]),_vm._v(" "),_c('div',{staticClass:"langWrapper"},[_c('span',{class:{on:_vm.lang==="en"},on:{"click":function($event){_vm.selectLanguage("en")}}},[_vm._v("English")]),_vm._v(" / \n\t\t\t"),_c('span',{class:{on:_vm.lang==="cn"},on:{"click":function($event){_vm.selectLanguage("cn")}}},[_vm._v("中文")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoWrapper"},[_c('img',{attrs:{"width":"57px","src":__webpack_require__("R9n1")}}),_vm._v(" "),_c('h1',{staticClass:"text_notion"},[_vm._v("NOTION")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#fff","line-height":"60px","font-size":"20px","font-weight":"600","padding-left":"10px"}},[_vm._v("information")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DbrZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_WINDOW_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PRODUCTSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PRODUCTLIST; });
var SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';

var SET_PRODUCT = 'SET_PRODUCT';

var SET_LANG = 'SET_LANG';

var SET_PRODUCTSH = 'SET_PRODUCTSH';

var SET_PRODUCTLIST = 'SET_PRODUCTLIST';

/***/ }),

/***/ "Gak4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export param */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__("hU7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);



function jsonp(url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_jsonp___default()(url, option, function (err, data) {
      if (!err) {
        resolve(data);
      } else {
        reject(err);
      }
    });
  });
}

function param(data) {
  var url = '';
  for (var k in data) {
    var value = data[k] !== undefined ? data[k] : '';
    url += '&' + k + '=' + encodeURIComponent(value);
  }
  return url ? url.substring(1) : '';
}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__ = __webpack_require__("sax8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
	getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
	state: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */],
	mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
	strict: debug,
	plugins: debug ? [__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default()()] : []
}));

/***/ }),

/***/ "IpHu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"textWrapper"},[_c('span',[_vm._v(_vm._s(_vm.footer1))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.footer2))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.footer3))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kf/3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = loadLanguage;
/* harmony export (immutable) */ __webpack_exports__["d"] = setLanguage;
/* harmony export (immutable) */ __webpack_exports__["e"] = setSourceDetail;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSourceDetail;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearSourceDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_good_storage__ = __webpack_require__("MfZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_good_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_good_storage__);



var LANGUAGE_KEY = 'notion_language';

var SOURCE_DETAIL = '__source_detail__';

function loadLanguage() {
	return __WEBPACK_IMPORTED_MODULE_1_good_storage___default.a.get(LANGUAGE_KEY, 'en');
}

function setLanguage(lang) {
	__WEBPACK_IMPORTED_MODULE_1_good_storage___default.a.set(LANGUAGE_KEY, lang);
}

function setSourceDetail(source) {
	source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(source);
	__WEBPACK_IMPORTED_MODULE_1_good_storage___default.a.set(SOURCE_DETAIL, source);
}

function getSourceDetail() {
	var source = __WEBPACK_IMPORTED_MODULE_1_good_storage___default.a.get(SOURCE_DETAIL, false);
	if (!source) {
		return false;
	}
	return JSON.parse(source);
}

function clearSourceDetail() {
	__WEBPACK_IMPORTED_MODULE_1_good_storage___default.a.remove(SOURCE_DETAIL);
}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e69a266_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("hBjN");
function injectStyle (ssrContext) {
  __webpack_require__("OlU4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e69a266"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e69a266_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick__ = __webpack_require__("v5o6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_index_js__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_stylus_index_styl__ = __webpack_require__("34KM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_stylus_index_styl__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default.a, {
  loading: __webpack_require__("DbrZ")
});

__WEBPACK_IMPORTED_MODULE_3_fastclick___default.a.attach(document.body);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_5__router_index_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]
});

/***/ }),

/***/ "OlU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R9n1":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "T452":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hostUrl; });
/* unused harmony export options */
/* unused harmony export commonParams */
/* unused harmony export ERR_OK */

var hostUrl = 'http://www.notioni.com:8091';
// export const hostUrl = 'http://47.74.253.193:8091'


var options = {
	param: 'jsonpCallback'
};

var commonParams = {};

var ERR_OK = 0;

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "windowW", function() { return windowW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "language", function() { return language; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "product", function() { return product; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lang", function() { return lang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productsH", function() { return productsH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prodctList", function() { return prodctList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("lwq5");


var windowW = function windowW(state) {
  return state.windowW;
};

var language = function language(state) {
  return state.language;
};

var product = function product(state) {
  return state.product;
};

var lang = function lang(state) {
  return state.lang;
};

var productsH = function productsH(state) {
  return state.productsH;
};

var prodctList = function prodctList(state) {
  return state.prodctList;
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



var Home = function Home(resolve) {
	__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "LqM4")).then(function (module) {
		resolve(module);
	});
};
var Products = function Products(resolve) {
	__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "Ox8V")).then(function (module) {
		resolve(module);
	});
};
var About = function About(resolve) {
	__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "6wUE")).then(function (module) {
		resolve(module);
	});
};
var Contact = function Contact(resolve) {
	__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "+QH9")).then(function (module) {
		resolve(module);
	});
};
var Certificate = function Certificate(resolve) {
	__webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "tjBf")).then(function (module) {
		resolve(module);
	});
};
var ProductDetail = function ProductDetail(resolve) {
	__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "tbIG")).then(function (module) {
		resolve(module);
	});
};
var Source = function Source(resolve) {
	__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Qak4")).then(function (module) {
		resolve(module);
	});
};
var SourceDetail = function SourceDetail(resolve) {
	__webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "cV6j")).then(function (module) {
		resolve(module);
	});
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: "/",
		redirect: "/home"
	}, {
		path: "/home",
		component: Home
	}, {
		path: "/products",
		component: Products,
		children: [{
			path: ":id",
			component: ProductDetail
		}]
	}, {
		path: "/about",
		component: About
	}, {
		path: "/contact",
		component: Contact
	}, {
		path: "/certificate",
		component: Certificate
	}, {
		path: '/source',
		component: Source,
		children: [{
			path: ":id",
			component: SourceDetail
		}]
	}]
}));

/***/ }),

/***/ "hBjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('tab'),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('footer-box')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lGbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("pYdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_accd1296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("IpHu");
function injectStyle (ssrContext) {
  __webpack_require__("nWCd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-accd1296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_accd1296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_cache__ = __webpack_require__("Kf/3");



var state = {
	windowW: 320,
	productsH: 1,
	product: {},
	prodctList: [],
	lang: Object(__WEBPACK_IMPORTED_MODULE_0_common_js_cache__["c" /* loadLanguage */])(),
	language: {
		products_btn_en: "VIEW",
		products_btn_cn: "查看",
		download_btn_en: "DOWNLOAD",
		download_btn_cn: "下载",
		pd_li_home_en: "Home",
		pd_li_products_en: "Products",
		pd_li_product_details_en: "Product Details",
		pd_li_home_cn: "主页",
		pd_li_products_cn: "产品",
		pd_li_product_details_cn: "产品详情",
		contact_name_en: "NAME",
		contact_name_cn: "姓名",
		contact_email_en: "Your email address or phone number",
		contact_email_cn: "你的联系方式（邮箱地址或电话号码）",
		contact_title_en: "TITLE",
		contact_title_cn: "标题",
		contact_btn_en: "SEND",
		contact_btn_cn: "发送",
		contact_message_en: "MESSAGE",
		contact_message_cn: "信息",
		contact_type_en: "Type",
		contact_type_cn: "类型",
		contact_company_en: "Company",
		contact_company_cn: "公司",
		error_company_en: 'Company can not be empty',
		error_company_cn: '公司不能为空',
		error_name_en: 'Name can not be empty',
		error_name_cn: '姓名不能为空',
		error_title_en: 'Title can not be empty',
		error_title_cn: '标题不能为空',
		error_message_en: 'Message can not be empty',
		error_message_cn: '信息不能为空',
		error_email_en: 'Email address or phone number can not be empty',
		error_email_cn: '联系方式不能为空',
		back_en: "back",
		back_cn: "返回",
		no_product_details_tip_en: "Sorry, the product information has not been uploaded.",
		no_product_details_tip_cn: "抱歉,还没有上传产品信息",
		wecode_text_cn: "79￥全网通4G模组重磅来袭",
		wecode_text_en: "79¥ Full Netcom 4G module hits heavy"
	}
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


function findIndex(list, song) {
	return list.findIndex(function (item) {
		return item.id === song.id;
	});
}

/***/ }),

/***/ "mtCj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nWCd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_footer__ = __webpack_require__("1cPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			footer1: '',
			footer2: '',
			footer3: ''
		};
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this._getFooterData();
		}, 20);
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['lang'])),
	methods: {
		_getFooterData: function _getFooterData() {
			var _this2 = this;

			Object(__WEBPACK_IMPORTED_MODULE_1_api_footer__["a" /* getFooterData */])(this.lang).then(function (res) {
				_this2.footer1 = res[0].comp_wish;
				_this2.footer2 = res[0].copyrightInfo;
				_this2.footer3 = res[0].name_upper;
			});
		}
	},
	watch: {
		lang: function lang() {
			this._getFooterData();
		}
	}
});

/***/ }),

/***/ "u7L+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__("wIWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f950c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_vue__ = __webpack_require__("44yY");
function injectStyle (ssrContext) {
  __webpack_require__("mtCj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77f950c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f950c1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SET_WINDOW_WIDTH */], function (state, val) {
	state.windowW = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_PRODUCT */], function (state, obj) {
	state.product = obj;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_LANG */], function (state, str) {
	state.lang = str;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_PRODUCTSH */], function (state, val) {
	state.productsH = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_PRODUCTLIST */], function (state, arr) {
	state.prodctList = arr;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "wIWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation__ = __webpack_require__("EhXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_home__ = __webpack_require__("xO/y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_dom__ = __webpack_require__("3Q4o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_cache__ = __webpack_require__("Kf/3");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			isShowMenu: false,
			menuArr: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this._getMenu();
		}, 20);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		miniMenu: function miniMenu() {
			if (!this.isShowMenu) {
				this.showMenu();
			} else {
				this.closeMenu();
			}
		},
		_getMenu: function _getMenu() {
			var _this2 = this;

			Object(__WEBPACK_IMPORTED_MODULE_2_api_home__["b" /* getMenu */])(this.lang).then(function (res) {
				_this2.menuArr = res;
			});
		},
		selectMenu: function selectMenu() {
			if (this.isShowMenu && this.windowW <= 900) {
				this.closeMenu();
			}
		},
		selectLanguage: function selectLanguage(val) {
			this.setLang(val);
			Object(__WEBPACK_IMPORTED_MODULE_5_common_js_cache__["d" /* setLanguage */])(val);
		},
		showMenu: function showMenu() {
			var _this3 = this;

			this.$refs.menu.style.display = 'block';
			Object(__WEBPACK_IMPORTED_MODULE_4_common_js_dom__["b" /* removeClass */])(this.$refs.icon, 'icon-menu');
			Object(__WEBPACK_IMPORTED_MODULE_4_common_js_dom__["a" /* addClass */])(this.$refs.icon, 'icon-close');
			var animation = {
				0: { height: '0px' },
				100: { height: this.$refs.menu.children.length * 56 + 'px' }
			};
			__WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation___default.a.registerAnimation({
				name: 'show',
				animation: animation,
				presets: {
					duration: 400,
					easing: 'linear'
				}
			});
			__WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation___default.a.runAnimation(this.$refs.menu, 'show');
			setTimeout(function () {
				_this3.$refs.menu.style.animation = "none";
			}, 400);

			this.isShowMenu = true;
		},
		closeMenu: function closeMenu() {
			var _this4 = this;

			var animation = {
				0: { height: this.$refs.menu.children.length * 56 + 'px' },
				100: { height: '0px' }
			};
			__WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation___default.a.registerAnimation({
				name: 'hide',
				animation: animation,
				presets: {
					duration: 400,
					easing: 'linear'
				}
			});
			__WEBPACK_IMPORTED_MODULE_1_create_keyframe_animation___default.a.runAnimation(this.$refs.menu, 'hide');
			setTimeout(function () {
				Object(__WEBPACK_IMPORTED_MODULE_4_common_js_dom__["b" /* removeClass */])(_this4.$refs.icon, 'icon-close');
				Object(__WEBPACK_IMPORTED_MODULE_4_common_js_dom__["a" /* addClass */])(_this4.$refs.icon, 'icon-menu');
				_this4.$refs.menu.style.display = 'none';
				_this4.$refs.menu.style.animation = "none";
			}, 400);
			this.isShowMenu = false;
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
		'setLang': 'SET_LANG'
	})),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['windowW', 'lang'])),
	watch: {
		windowW: function windowW(newVal, oldVal) {
			if (newVal <= 1000) {
				this.$refs.menu.style.display = 'none';
			} else {
				this.$refs.menu.style.display = 'flex';
			}
		},
		lang: function lang() {
			this._getMenu();
		}
	}
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_tab_tab__ = __webpack_require__("u7L+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_footer_footer__ = __webpack_require__("lGbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//




// import Wecode from './base/wecode/wecode'

/* harmony default export */ __webpack_exports__["a"] = ({
	created: function created() {
		this.changeView();
		this.recalc();
	},

	computed: {},
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		changeView: function changeView() {
			var docEl = document.documentElement;
			var resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";

			if (document.addEventListener) {
				window.addEventListener(resizeEvt, this.recalc, false);
				document.addEventListener("DOMcontentLoaded", this.recalc, false);
			} else if (document.attachEvent) {
				document.attachEvent("on" + resizeEvt, this.recalc);
				document.attachEvent("on" + "DOMcontentLoaded", this.recalc);
			}
		},
		recalc: function recalc() {
			this.setWidth(window.innerWidth);
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])({
		setWidth: 'SET_WINDOW_WIDTH'
	})),
	components: {
		Tab: __WEBPACK_IMPORTED_MODULE_1__base_tab_tab__["a" /* default */], FooterBox: __WEBPACK_IMPORTED_MODULE_2__base_footer_footer__["a" /* default */]
	}
});

/***/ }),

/***/ "xO/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHome;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_jsonp_js__ = __webpack_require__("Gak4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__("T452");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var debug = "production" !== 'production';

function getHome(lang) {
	var url = '/api/getHome';
	var data = { lang: lang };
	return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
		params: data
	}).then(function (res) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
	});
}

function getMenu(lang) {
	var url = '/api/getMenu';
	var data = { lang: lang };
	return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
		params: data
	}).then(function (res) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
	});
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.82e3d5f58c580a16e7e3.js